import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Grid,
  Autocomplete,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import classes from "./OBTContactRoster.module.css";
import BackdropComponent from "../Spinner/Spinner";
import styled from "@mui/material/styles/styled";

import { getClassRosterIds } from "../../services/userServices";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import contactRosterGraphic from "../../assets/images/ContactRoster1.svg";

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));

const OBTContactRoster = () => {
  const [classRosterRequired, setClassRosterRequired] = useState(false);
  const [rosterIds, setRosterIds] = useState([]);
  const [selectedRosterId, setSelectedRosterId] = useState("");
  const [selectedOptions, setSelectedOptions] = useState("");
  const [loading, setLoader] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const fetchRoster = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        await rosterList();
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch roster:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchRoster();

    return () => {
      cancelled = true;
    };
  }, []);

  const rosterList = useCallback(async () => {
    let userDetails = await getClassRosterIds();
    setRosterIds(
      userDetails.data.data.map((item) => item.ClassRosterId.toString()),
    );
    setSelectedRosterId(userDetails.data.data[0].ClassRosterId.toString());
  }, []);

  const handleChange = (event, value) => {
    setClassRosterRequired(false);
    setSelectedOptions(value);
  };

  const viewButton = (id) => {
    if (selectedOptions) {
      window.open(`/contact-roster/${selectedOptions}`, "_blank");
      applicationUsageLog(
        localStorage.getItem("User"),
        localStorage.getItem("EmailId"),
        "ASTT",
        "Contact Roster",
      );
    } else {
      setClassRosterRequired(true);
    }
  };
  return (
    <>
      {" "}
      {loading ? <BackdropComponent /> : null}
      <Card sx={{ marginBottom: 1 }}>
        <CardContent>
          <Typography
            sx={{
              color: "#8c8c8c",
              fontFamily: "Urbanist, sans-serif",
              fontSize: "1.75rem",
            }}
          >
            <img
              className={classes.contactRosterGraphic}
              src={contactRosterGraphic}
              alt="TTEC"
            />{" "}
            Hi <strong>{localStorage.getItem("User")}</strong>
          </Typography>
        </CardContent>
      </Card>
      <Card
        sx={{
          height: "calc(85vh - 100px)",
          overflowY: "auto",
        }}
      >
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="h5"
                className={classes.rosterHeading}
                sx={{
                  fontSize: "1.75rem",
                  fontFamily: "Urbanist, sans-serif",
                  color: "#3F5765",
                }}
              >
                Contact Roster
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h7">
                Select the Class Roster ID from the drop-down below and click
                the 'Generate Report' button. This will open a new tab with your
                report.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                <Autocomplete
                  disablePortal
                  options={rosterIds}
                  sx={{ width: 250 }}
                  onChange={(event, value) => handleChange(event, value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label={
                        <span>
                          Select Class Roster{" "}
                          <Box component="span" sx={{ color: "red" }}>
                            *
                          </Box>
                        </span>
                      }
                    />
                  )}
                />
                <CustomButton
                  variant="contained"
                  onClick={() => viewButton(selectedRosterId)}
                >
                  Generate Report
                </CustomButton>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <p className="redColor">
                {classRosterRequired && "Required Field"}
              </p>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h2"
                sx={{
                  color: "red",
                  p: 1.25, // 10px = 1.25 * 8px (MUI spacing unit)
                  textAlign: "left",
                }}
              >
                IMPORTANT!
              </Typography>

              <Typography
                sx={{
                  padding: "10px",
                  textAlign: "left",
                  fontSize: "15px",
                }}
              >
                Document Security begins with all of us!
                <br />
                <br />
                <Box
                  component="span"
                  sx={{ display: "block", marginTop: "10px" }}
                >
                  Please 'Act As One' and ensure that if you copy and paste this
                  information into another document (e.g. Excel), that you
                  follow Data Security Standards and password-protect any
                  documents where this information may be used or shared!
                </Box>
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
export default OBTContactRoster;
